import MasonryWall from "@yeger/vue-masonry-wall"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("masonry-wall", MasonryWall, {})
})
